// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveSecondaryProgramDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryProgramDTO from '../models/SecondaryProgramDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    secondaryProgramId: string | null | null;
    secondaryProgram: SecondaryProgramDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            secondaryProgramId: null,
            secondaryProgram: null,
        },
        initValues);
    },
    secondaryProgramId: 'secondaryProgramId',
    secondaryProgram: 'secondaryProgram',
}

interface Result extends ResultDTO {
    secondaryProgram: SecondaryProgramDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryProgram: null,
        },
        initValues);
    },
    secondaryProgram: 'secondaryProgram',
}

export { Request, Result };